import { CloseOutlined } from "@ant-design/icons";
import { Separator } from "../../../../../styles/titles";
import modal from "../../../../usuarios/components/modal";
import {
  BankGridRow,
  CloseButton,
  ConfirmationModal,
  Description,
  GridCell,
  GridContainer,
  GridHeader,
  Item,
  ModalContent,
  ModalHeader,
  OverlayStyle,
  TextGroup,
} from "../../../styles";
import {
  formatCommitValue,
  formatMoneyView,
  formatPaymentRecipientType,
} from "../../../../../utils/formatViews";
import { BankModalValues, ContractEffectBankData } from "./types";

export const BankModal: React.FC<BankModalValues> = (props) => {
  const { isShowing, modalData, onClose } = props;

  if (!modalData) {
    return null;
  }

  return (
    <>
      {isShowing && (
        <>
          <OverlayStyle onClick={onClose} />
          <ConfirmationModal onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Hash da UR: {modalData?.hash}</h2>
              <CloseButton onClick={onClose}>
                <CloseOutlined />
              </CloseButton>
            </ModalHeader>

            <Separator />

            <GridContainer>
              <BankGridRow header>
                <GridHeader>Ordem do Efeito</GridHeader>
                <GridHeader>Valor Comprometido</GridHeader>
                <GridHeader>Valor Transferido</GridHeader>
                <GridHeader>Destinatario</GridHeader>
                <GridHeader>ISPB</GridHeader>
                <GridHeader>Código do Banco</GridHeader>
                <GridHeader>Banco</GridHeader>
                <GridHeader>Agência</GridHeader>
                <GridHeader>Conta com Dígito</GridHeader>
                <GridHeader>Documento do Titular</GridHeader>
              </BankGridRow>

              {modalData.records.map(
                (transaction: ContractEffectBankData, index: number) => (
                  <BankGridRow key={index}>
                    <GridCell>{transaction?.contractEffectIndicator ?? "-"}</GridCell>
                    <GridCell>
                      {formatCommitValue(transaction?.committedValue, transaction?.divisionRules)}
                    </GridCell>
                    <GridCell>
                      {transaction?.amountToPay
                        ? formatMoneyView(transaction.amountToPay)
                        : "R$ 0.00"}
                    </GridCell>
                    <GridCell>
                      {transaction?.paymentRecipientType
                        ? formatPaymentRecipientType(
                            transaction.paymentRecipientType
                          )
                        : "-"}
                    </GridCell>
                    <GridCell>{transaction?.ispb || "-"}</GridCell>
                    <GridCell>{transaction?.bankCode || "-"}</GridCell>
                    <GridCell>{transaction?.bankName || "-"}</GridCell>
                    <GridCell>{transaction?.bankBranch || "-"}</GridCell>
                    <GridCell>{transaction?.accountNumber || "-"}</GridCell>
                    <GridCell>
                      {transaction?.holderDocumentNumber || "-"}
                    </GridCell>
                  </BankGridRow>
                )
              )}
            </GridContainer>
          </ConfirmationModal>
        </>
      )}
    </>
  );
};
